'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var MESSAGING_LOADED = 'messaging:loaded';
var MESSAGING_MARK_READ = 'messaging:mark-read';
var MESSAGING_LIST = 'messaging:list';
var MESSAGING_UNREAD_LIST = 'messaging:unread-list';

exports.MESSAGING_LIST = MESSAGING_LIST;
exports.MESSAGING_LOADED = MESSAGING_LOADED;
exports.MESSAGING_MARK_READ = MESSAGING_MARK_READ;
exports.MESSAGING_UNREAD_LIST = MESSAGING_UNREAD_LIST;
